/*eslint no-unused-vars: ["warn", { "varsIgnorePattern": "[iI]gnored" }]*/

import K from '../constants';
import restHelpers from '../helpers/restHelper';

const summaryFn = (dealers) => restHelpers.withBearer.get(restHelpers.dealersQueryString(`${K.API_URL}/leads/summary?_=${new Date().getTime()}`, dealers), {});

const getFn = (dealers) => restHelpers.withBearer.get(restHelpers.dealersQueryString(`${K.API_URL}/leads?_=${new Date().getTime()}`, dealers), {});

const statusSummaryFn = (dealers) => restHelpers.withBearer.get(restHelpers.dealersQueryString(`${K.API_URL}/leads/status?_=${new Date().getTime()}`, dealers), {});

const addReservationFn = (leadId, carId, reservationDate) => restHelpers.withBearer.post(`${K.API_URL}/reservations`, { data: { leadId, carId, reservationDate } });

const deleteReservationFn = reservationId => restHelpers.withBearer.delete(`${K.API_URL}/reservations/${reservationId}`);

const updateReservationFn = (reservationId, reservationDate) => restHelpers.withBearer.put(`${K.API_URL}/reservations/${reservationId}`, { data: { reservationDate } });

const getReservationsHistoryFn = (carId, page = 1, sort = '', order = '') =>
  restHelpers.withBearer.get(
    `${K.API_URL}/reservations/cars/${carId}/history?_=${new Date().getTime()}&page=${page - 1}&size=10${sort !== '' && order !== '' ? `&sort=${sort}&order=${order}` : ''}`,
    {}
  );

const clientFidelityFn = clientId => restHelpers.withBearer.get(`${K.API_URL}/clients/fidelity-info/${clientId}?_=${new Date().getTime()}`, {});
const clientsFidelityFn = () => restHelpers.withBearer.get(`${K.API_URL}/clients/fidelity-info/all?_=${new Date().getTime()}`, {});

const suspendFn = ids => restHelpers.withBearer.post(`${K.API_URL}/leads/suspend`, { data: { ids } });

const sendSmsFn = (message, carId, leadId) => restHelpers.withBearer.post(`${K.API_URL}/communications`, { data: { message, medium: 'sms', carId, leadId, direction: 'out' } });

const sendEmailFn = (message, carId, leadId) => restHelpers.withBearer.post(`${K.API_URL}/communications`, { data: { message, medium: 'email', carId, leadId, direction: 'out' } });

const discardFn = (reason, leadId) => restHelpers.withBearer.post(`${K.API_URL}/leads/discard`, { data: { id: leadId, closeOrDiscardReason: reason } });

const actionFn = leadId => restHelpers.withBearer.post(`${K.API_URL}/leads/action`, { data: { id: leadId } });

export default {
  summary: summaryFn,
  statusSummary: statusSummaryFn,
  get: getFn,
  addReservation: addReservationFn,
  deleteReservation: deleteReservationFn,
  updateReservation: updateReservationFn,
  getReservationsHistory: getReservationsHistoryFn,
  clientFidelity: clientFidelityFn,
  clientsFidelity: clientsFidelityFn,
  suspend: suspendFn,
  sendSms: sendSmsFn,
  sendEmail: sendEmailFn,
  discard: discardFn,
  action: actionFn
};
